import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateDirectorySyncSettings as UpdateDirectorySyncSettingsMutation,
    UpdateDirectorySyncSettingsVariables as UpdateDirectorySyncSettingsVariables,
    UpdateDirectorySyncSettingsInput,
} from 'nutshell-graphql-types';

import UPDATE_DIRECTORY_SYNC_SETTINGS from '../mutations/update-directory-sync-settings.graphql';

export const useUpdateDirectorySyncSettings = (): {
    updateDirectorySyncSettings: (arg1: UpdateDirectorySyncSettingsInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateDirectorySyncSettings, {loading, error}] = useMutation<
        UpdateDirectorySyncSettingsMutation,
        UpdateDirectorySyncSettingsVariables
    >(UPDATE_DIRECTORY_SYNC_SETTINGS);

    return {
        updateDirectorySyncSettings: (input: UpdateDirectorySyncSettingsInput) =>
            updateDirectorySyncSettings({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
